import routerDataActions from 'store/redux/routerData'
import { LOCATION_CHANGE } from 'connected-react-router'

const screenTracking = ({ dispatch }) => next => action => {
    if (action.type === LOCATION_CHANGE) {
        dispatch(routerDataActions.setLocation(action.payload))
    }
    return next(action)
}

export default screenTracking



// WEBPACK FOOTER //
// src/store/middlewares/locationTracking.js